import {
  Component,
  ChangeDetectionStrategy,
  Inject,
  OnInit,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DprCard } from '@dpr/models';

import { StaticMessage, UtcDateTimeOptions } from '@shared/enums';
import { UtcDateAdapter } from '@shared/material/date-picker';
import { DateFilter } from '@shared/models';
import { Constants, filterAvailableDates, toUTCDate } from '@shared/utils';

@Component({
  selector: 'app-setup-dpr-date-modal',
  templateUrl: './setup-dpr-date-modal.component.html',
  styleUrls: ['./setup-dpr-date-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetupDprDateModalComponent implements OnInit {
  selectedDate: Date;
  firstAvailableDate: Date;
  minDate = toUTCDate(
    new Date(Constants.DateTime.MinConfigurableDate),
    UtcDateTimeOptions.UtcDateWithoutTime
  );
  maxDate = toUTCDate(
    new Date(Constants.DateTime.MaxConfigurableDate),
    UtcDateTimeOptions.UtcDateWithoutTime
  );
  title = $localize`:@@dpr.setupDprDateModal.titleNewDpr:New DPR`;
  StaticMessage = StaticMessage;

  constructor(
    public dialogRef: MatDialogRef<SetupDprDateModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      lastDprDate: Date;
      dprCards: DprCard[];
      existingDprDates: DateFilter;
      createdDates: number[];
      isAppOnline: boolean;
      isSystemAdmin: boolean;
    },
    private utcDateAdapter: UtcDateAdapter
  ) {}

  ngOnInit(): void {
    const lastDprDate = this.data.lastDprDate
      ? new Date(this.data.lastDprDate)
      : null;

    if (lastDprDate) {
      this.firstAvailableDate = this.utcDateAdapter.addCalendarDays(
        lastDprDate,
        1
      );

      this.minDate = this.computeMinDate();
    }
  }

  onCreateDpr(): void {
    this.dialogRef.close(this.selectedDate);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  filterAvailableDates = (date: Date): boolean => {
    if (this.data.isAppOnline) {
      return filterAvailableDates(date, this.data.existingDprDates);
    }
    return true;
  };

  clearSelectedDate(): void {
    this.selectedDate = null;
  }

  private computeMinDate(): Date {
    const minConfigurableDate = toUTCDate(
      new Date(Constants.DateTime.MinConfigurableDate),
      UtcDateTimeOptions.UtcDateWithoutTime
    );
    if (!this.data.isAppOnline) {
      return this.firstAvailableDate;
    }

    if (this.data.isSystemAdmin) {
      return minConfigurableDate;
    }

    const firstDateUTC = toUTCDate(
      this.data.existingDprDates.firstDate,
      UtcDateTimeOptions.UtcDateWithoutTime
    );

    const oneMonthPriorDate = this.utcDateAdapter.addCalendarMonths(
      firstDateUTC,
      -1
    );

    return oneMonthPriorDate < new Date(Constants.DateTime.MinConfigurableDate)
      ? minConfigurableDate
      : oneMonthPriorDate;
  }
}
